import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { AuthService } from './auth.service';
import { HttpRequestService } from './HttpRequestService';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRest}`;
  private readonly triidyServiceUrlRestSale = `${environment.apiTriidyUrlRestSales}/api`;
  private readonly triidyServiceUrlRestSaleApi = `${environment.apiTriidyUrlVentas}/api`;

  constructor(private http: HttpClient,
    private httpRequestService: HttpRequestService, private authService: AuthService) { }

  getUrlDetalle(cadena_producto: any): Observable<any> {

    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      cadena_producto,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetURLDetalle`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getProductoCheckout(id_producto: any, id_tienda: any): Observable<any> {

    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_producto,
      id_tienda,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetProductoCheckOut`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getCiudadesCheckout(id_ciudad_origen: any, codigoPais): Observable<any> {

    const token = environment.serviceToken;
    // const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const codigo_pais = codigoPais;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_ciudad_origen,
      codigo_pais,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetCiudadesCheckOut`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  guardarCliente(clientData: any, codigoPais): Observable<any[]> {
    const token = environment.serviceToken;
    clientData.token = token;
    clientData.codigo_pais = codigoPais;
    // clientData.codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    // console.log(clientData)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/Clientes`, clientData)
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  guardarVenta(saleData: any): Observable<any[]> {
    const token = environment.serviceToken;
    saleData.token = token;
    saleData.key = 'NA';
    saleData.formulario = 'checkout';
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSaleApi}/GenerarVenta`, saleData)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta)
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  linkCheckout(dataLink): Observable<any[]> {
    const token = environment.serviceToken;
    // let detail = JSON.parse(detalle_venta2);
    // console.log(detail[0].detalle)
    dataLink.token = token;
    // console.log(dataLink)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/WebCheckout`, dataLink)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

}
